import { IPagination } from 'app/types/common';

export interface IPaymentEvent {
  id: string;
  description: string;
  status: string;
  reference: string;
  organisation: { id: string };
  groupOneName: string;
  groupOneCode?: any;
  groupOnePaymentAmount: number;
  groupOnePaymentStatus: string;
  groupOnePaymentTransferStatus?: any;
  groupOnePaymentCategory: string;
  groupOnePaymentMetadata: { id: string };
  groupOnePaymentPaidAt?: any;
  groupOnePaymentReceiptReference?: any;
  groupTwoName: string;
  groupTwoCode?: any;
  groupTwoPaymentAmount: number;
  groupTwoPaymentStatus: string;
  groupTwoPaymentTransferStatus?: any;
  groupTwoPaymentCategory: string;
  groupTwoPaymentMetadata: { id: string };
  groupTwoPaymentPaidAt?: any;
  groupTwoPaymentReceiptReference?: any;
  paymentEnabled: boolean;
  locationInfo: string;
  eventInfo: string;
  sectionTag: string;
  seasonTag: string;
  eventAt: Date;
  createdAt: Date;
  updatedAt: Date;
  lastSyncedAt?: any;
  groupOnePaymentCollectionReference: string;
  groupTwoPaymentCollectionReference: string;
  groupOneSubscriptionPayment: { id: string };
  groupTwoSubscriptionPayment: { id: string };
  groupOne: { id: string };
  groupTwo: { id: string };
  groupOnePayment: { id: string };
  groupTwoPayment: { id: string };
  groupOnePaymentCollection: { id: string };
  groupTwoPaymentCollection: { id: string };
  groupOneMatchPayment: { id: string };
  groupOneForfeit: { id: string };
  groupTwoMatchPayment: { id: string };
  groupTwoForfeit: { id: string };
  groupOneForfeitPaymentCollection: { id: string };
  groupTwoForfeitPaymentCollection: { id: string };
}

export interface IPaymentEventsState {
  readonly paymentEventsById?: any;
  readonly paymentEventIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddPaymentEvent?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPaymentEventIds?: string[];
  readonly currentPaymentEventId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPaymentEventsSelector extends IPaymentEventsState {
  readonly currentPaymentEvent?: any;
  readonly currentFormPaymentEvent?: any;
  readonly getPaymentEventsFilteredByTagInSelectFormat?: any;
  readonly paymentEventsByIdInSelectFormat?: any;
  readonly paymentEventsByIdSortedDate?: any;
}

export enum PaymentEventsActionTypes {
  GET_ALL_PAYMENT_EVENTS_REQUESTED = 'redux-app/payment-events/GET_ALL_PAYMENT_EVENTS_REQUESTED',
  GET_ALL_PAYMENT_EVENTS_PENDING = 'redux-app/payment-events/GET_ALL_PAYMENT_EVENTS_PENDING',
  GET_ALL_PAYMENT_EVENTS_SUCCESS = 'redux-app/payment-events/GET_ALL_PAYMENT_EVENTS_SUCCESS',
  GET_ALL_PAYMENT_EVENTS_FAIL = 'redux-app/payment-events/GET_ALL_PAYMENT_EVENTS_FAIL',
  GET_ALL_PAYMENT_EVENTS_FOR_ALL_TEAMS_REQUESTED = 'redux-app/payment-events/GET_ALL_PAYMENT_EVENTS_FOR_ALL_TEAMS_REQUESTED',
  GET_ALL_PAYMENT_EVENTS_FOR_ALL_TEAMS_PENDING = 'redux-app/payment-events/GET_ALL_PAYMENT_EVENTS_FOR_ALL_TEAMS_PENDING',
  GET_ALL_PAYMENT_EVENTS_FOR_ALL_TEAMS_SUCCESS = 'redux-app/payment-events/GET_ALL_PAYMENT_EVENTS_FOR_ALL_TEAMS_SUCCESS',
  GET_ALL_PAYMENT_EVENTS_FOR_ALL_TEAMS_FAIL = 'redux-app/payment-events/GET_ALL_PAYMENT_EVENTS_FOR_ALL_TEAMS_FAIL',
  GET_PAYMENT_EVENT_REQUESTED = 'redux-app/payment-events/GET_PAYMENT_EVENT_REQUESTED',
  GET_PAYMENT_EVENT_PENDING = 'redux-app/payment-events/GET_PAYMENT_EVENT_PENDING',
  GET_PAYMENT_EVENT_SUCCESS = 'redux-app/payment-events/GET_PAYMENT_EVENT_SUCCESS',
  GET_PAYMENT_EVENT_FAIL = 'redux-app/payment-events/GET_PAYMENT_EVENT_FAIL',
  UPDATE_PAYMENT_EVENT_REQUESTED = 'redux-app/payment-events/UPDATE_PAYMENT_EVENT_REQUESTED',
  UPDATE_PAYMENT_EVENT_PENDING = 'redux-app/payment-events/UPDATE_PAYMENT_EVENT_PENDING',
  UPDATE_PAYMENT_EVENT_SUCCESS = 'redux-app/payment-events/UPDATE_PAYMENT_EVENT_SUCCESS',
  UPDATE_PAYMENT_EVENT_FAIL = 'redux-app/payment-events/UPDATE_PAYMENT_EVENT_FAIL',
  CREATE_PAYMENT_EVENT_REQUESTED = 'redux-app/payment-events/CREATE_PAYMENT_EVENT_REQUESTED',
  CREATE_PAYMENT_EVENT_PENDING = 'redux-app/payment-events/CREATE_PAYMENT_EVENT_PENDING',
  CREATE_PAYMENT_EVENT_SUCCESS = 'redux-app/payment-events/CREATE_PAYMENT_EVENT_SUCCESS',
  CREATE_PAYMENT_EVENT_FAIL = 'redux-app/payment-events/CREATE_PAYMENT_EVENT_FAIL',
  DELETE_PAYMENT_EVENT_REQUESTED = 'redux-app/payment-events/DELETE_PAYMENT_EVENT_REQUESTED',
  DELETE_PAYMENT_EVENT_PENDING = 'redux-app/payment-events/DELETE_PAYMENT_EVENT_PENDING',
  DELETE_PAYMENT_EVENT_SUCCESS = 'redux-app/payment-events/DELETE_PAYMENT_EVENT_SUCCESS',
  DELETE_PAYMENT_EVENT_FAIL = 'redux-app/payment-events/DELETE_PAYMENT_EVENT_FAIL',
  SELECT_PAYMENT_EVENT_REQUESTED = 'redux-app/payment-events/SELECT_PAYMENT_EVENT_REQUESTED',
}

export default null;
